import {cn} from 'platform/shared-tw';

import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface RearRightBrakeProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function RearRightBrake(props: RearRightBrakeProps) {
  return (
    <svg
      width="110"
      height="16"
      viewBox="0 0 110 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute [pointer-events:none] cursor-pointer group"
      style={{top: 74, right: 247}}
      onClick={props.onClick}
    >
      <path
        d="M3 9H43V1H67V9H77V13H3C3 13 1 13 1 11C1 9 3 9 3 9Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M105 15H93H81C78 15 77 14 77 11C77 8 78 7 81 7H93H105C108 7 109 8 109 11C109 14 108 15 105 15Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M105 15H93H81C78 15 77 14 77 11C77 8 78 7 81 7H93H105C108 7 109 8 109 11C109 14 108 15 105 15Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M77 13H3C3 13 1 13 1 11C1 9 3 9 3 9H77"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <rect
        x="43"
        y="1"
        width="24"
        height="8"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
    </svg>
  );
}
